import { css } from '@emotion/core';
import { mq } from '../../cssInJs';
export default {
  button: css(mq({
    position: 'absolute',
    left: '1rem',
    lineHeight: '1.6rem',
    color: 'white',
    fontWeight: 600,
    fontSize: ['12px', null, '15px']
  })),
}